import { NavLink } from "react-router-dom";
import { AxonIcon } from "../../icons/AxonIcon.jsx";
import { useNotifications } from "./NotificationsProvider.jsx";

export function NotificationsBell({ className = "" }) {
  const { unreadCount } = useNotifications();
  const label = unreadCount
    ? `Уведомления, непрочитанных: ${unreadCount}`
    : "Уведомления";

  return (
    <NavLink
      to="/notifications"
      className={({ isActive }) => (
        `notifications-bell${isActive ? " is-active" : ""}${className ? ` ${className}` : ""}`
      )}
      aria-label={label}
      title={label}
    >
      <AxonIcon name="notification" size={20} />
      {unreadCount ? (
        <span className="notifications-bell__count" aria-hidden="true">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      ) : null}
    </NavLink>
  );
}
